import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import Button from '@chama/ui-components/components/ButtonNew';

import './ProductsFormActions.css';

export default function FormActions({
  hasProducts,
  isEditing,
  isSavingDisabled,
  onToggleEditMode,
  onResetForm,
  onSubmitForm,
  onShowAddProductForm,
  dealerCanAddProducts,
}) {
  const handleCancel = () => {
    onToggleEditMode();
    onResetForm();
  };

  const readMode = hasProducts && (
    <Button variant="primary" onClick={onToggleEditMode}>
      <FormattedMessage id="edit" />
    </Button>
  );

  const editMode = (
    <Fragment>
      <Button variant="secondary" onClick={handleCancel}>
        <FormattedMessage id="cancel" />
      </Button>
      <Button variant="primary" onClick={onSubmitForm} isDisabled={isSavingDisabled}>
        <FormattedMessage id="save" />
      </Button>
    </Fragment>
  );

  const addMode = (
    <div className="ProductsFormActions__buttons">
      <Button
        className="ProductsFormActions__add-product"
        variant="neutral"
        onClick={onShowAddProductForm}
      >
        <FormattedMessage id="add_product" />
      </Button>
    </div>
  );

  const className = classnames('ProductsFormActions', {
    'no-products': !hasProducts,
    'ProductsFormActions--editing': isEditing,
  });

  const canAddProduct = dealerCanAddProducts && !isEditing;

  return (
    <div className={className}>
      {canAddProduct && addMode}
      <div className="ProductsFormActions__buttons ProductsFormActions__buttons--main">
        {isEditing ? editMode : readMode}
      </div>
    </div>
  );
}
FormActions.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  hasProducts: PropTypes.bool.isRequired,
  isSavingDisabled: PropTypes.bool.isRequired,
  onToggleEditMode: PropTypes.func.isRequired,
  onResetForm: PropTypes.func.isRequired,
  onSubmitForm: PropTypes.func.isRequired,
  onShowAddProductForm: PropTypes.func.isRequired,
  dealerCanAddProducts: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ../ui-components/components/DealerProducts/ProductsFormActions/ProductsFormActions.jsx